
import React from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function MeverFeatures() {
  const { ref, isVisible } = useScrollAnimation();

  const features = [
    {
      icon: 'ri-pencil-ruler-2-line',
      titleJa: '素材へのこだわり',
      titleEn: 'Material First',
      descJa: '天然木、本革、アルミニウム。手に触れるものだからこそ、素材の質感を大切にしています。',
      descEn: 'Natural wood, genuine leather, aluminum. We prioritize material quality for everything you touch.',
    },
    {
      icon: 'ri-layout-line',
      titleJa: 'ミニマルな設計',
      titleEn: 'Minimal Design',
      descJa: '余計な装飾を排し、機能と美しさが一体となったデザインを追求します。',
      descEn: 'We pursue design where function and beauty are one, eliminating unnecessary decoration.',
    },
    {
      icon: 'ri-recycle-line',
      titleJa: '長く使える品質',
      titleEn: 'Built to Last',
      descJa: '流行に左右されない普遍的なデザインと、長期間の使用に耐える堅牢な構造。',
      descEn: 'Timeless design and robust construction built for years of daily use.',
    },
  ];

  return (
    <section
      ref={ref}
      className="py-28 lg:py-36 px-8 lg:px-32 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div
          className={`text-center mb-20 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-4xl lg:text-5xl font-medium text-gray-900 mb-4">
            Design Philosophy
          </h2>
          <p className="text-base text-gray-500">デザインフィロソフィー</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{
                transitionDelay: isVisible ? `${index * 150 + 200}ms` : '0ms',
              }}
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-8 bg-gray-50 rounded-2xl">
                <i className={`${feature.icon} text-2xl text-gray-900`}></i>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                {feature.titleJa}
              </h3>
              <p className="text-sm font-medium text-gray-500 mb-5">
                {feature.titleEn}
              </p>
              <p className="text-sm text-gray-600 leading-relaxed mb-2">
                {feature.descJa}
              </p>
              <p className="text-sm text-gray-400 leading-relaxed">
                {feature.descEn}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
